import { useCallback } from "react";
import { useNavigate, useSearchParams as useRouterSearchParams } from "react-router-dom";

import { useSearchParams } from "../../shared/hooks";

const LENS_ID_PARAM = "lensId";

interface UseLensIdSearchParameterResult {
    lensId: string | null;
    setLensId: (lensId: string, path?: string) => void;
    clearLensId: () => void;
}

export const useLensIdSearchParameter = (): UseLensIdSearchParameterResult => {
    const navigate = useNavigate();
    const searchParams = useSearchParams();
    const [, setSearchParams] = useRouterSearchParams();
    const lensId = searchParams.get(LENS_ID_PARAM);

    const setLensId = useCallback(
        (nextLensId: string, path?: string) => {
            if (path) {
                const nextSearchParams = new URLSearchParams(window.location.search);
                nextSearchParams.set(LENS_ID_PARAM, nextLensId);
                navigate(`${path}?${nextSearchParams.toString()}`, { replace: true });
                return;
            }

            setSearchParams(
                (prev) => {
                    const nextSearchParams = new URLSearchParams(prev);
                    nextSearchParams.set(LENS_ID_PARAM, nextLensId);
                    return nextSearchParams;
                },
                { replace: true, preventScrollReset: true },
            );
        },
        [navigate, setSearchParams],
    );

    const clearLensId = useCallback(() => {
        setSearchParams(
            (prev) => {
                const nextSearchParams = new URLSearchParams(prev);
                nextSearchParams.delete(LENS_ID_PARAM);
                return nextSearchParams;
            },
            { replace: true, preventScrollReset: true },
        );
    }, [setSearchParams]);

    return { lensId, setLensId, clearLensId };
};
